<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iyl7Ot/tc-custom/9781646561735.jpg?1723592038547" alt="This image is the cover for the book Matthew's Present"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Matthew's Present
      </h1>
      <p class="bookDescription body article font2">
        <p>Christmas is around the corner and Matthew Blick is not looking forward to spending another holiday alone. His five-year-old niece, Hannah, loves her uncle so much, she asks the department store Santa to bring her uncle someone to love.<br/><br/>When Santa shows up at Matthew’s house, he doesn’t recognize him. As memories of his first kiss rush back, he’s shocked to find the man he hasn’t been able to get out of his mind since high school. Can a kiss change the way Matthew feels about Christmas?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Hadley Brook
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c9625cce